import React from 'react';

const Electrodomesticos = () => {
    return ( 
        <h1>Desde Electro</h1>
     );
}
 
export default Electrodomesticos;